import React from 'react';
import styled from 'styled-components';
import { AnimatedDiv } from '@ibinder/common-frontend';
import { useFeatureToggle } from '@ibinder/ui-common-hooks';
import { RightPanel } from 'Shared/css/panel';
import TabContainer from './tabContainer';

// Feature toggle
import { Config } from '@ibinder/common-utils';
import { getTabs } from '../placeholderData';

const AnimatedTabDiv = styled(AnimatedDiv)`
  width: auto;
  height: calc(100% - 1rem);
`;

const RightTabsMenu = ({
  rightPanelOpen,
  toggleTabsMenu,
  BINDER_NAME,
  binderSpread
}) => {
  const { isEnabled: showBatchOperations } = useFeatureToggle(
    'batchOperations',
    Config.OPERATIONAL_CONFIG
  );

  // TODO when we no longer need the feature toggle remove this and just use tabs instead
  const theTabs = getTabs(showBatchOperations);

  return (
    <AnimatedTabDiv>
      <RightPanel
        loading={false}
        isOpen={rightPanelOpen}
        togglepanel={toggleTabsMenu}
      >
        <TabContainer
          data={theTabs}
          binderName={BINDER_NAME}
          toggleTabsMenu={toggleTabsMenu}
          binderSpread={binderSpread}
        />
      </RightPanel>
    </AnimatedTabDiv>
  );
};

export default RightTabsMenu;
